<template>
  <div>
    <el-dialog :title="$t('merchant.add_merchant_app')" :close-on-click-modal="false" :visible.sync="dialogUserVisible" width="900px" @close="closeModal">
      <el-form ref="form" :model="form" class="form-container" label-width="150px" label-position="left">
        <el-form-item :label="$t('merchant.notice_webhook')" prop="notice_webhook">
          <el-input v-model="form.notice_webhook" size="small" :placeholder="$t('merchant.notice_webhook')" class="search-frame" autocomplete="off" clearable />
        </el-form-item>

        <el-form-item :label="$t('merchant.callback_event_list')">
          <el-checkbox-group v-model="form.event_names">
            <el-checkbox v-for="(event, index) in eventList" :key="event" :label="event">{{ event + eventIsWithBr(index) }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item :label="$t('merchant.qrcode_webhook')" prop="qrcode_webhook">
          <el-input v-model="form.qrcode_webhook" size="small" :placeholder="$t('merchant.qrcode_webhook')" class="search-frame" autocomplete="off" clearable />
        </el-form-item>
        <el-form-item :label="$t('merchant.transfer_webhook')" prop="transfer_webhook">
          <el-input v-model="form.transfer_webhook" size="small" :placeholder="$t('merchant.transfer_webhook')" class="search-frame" autocomplete="off" clearable />
        </el-form-item>

        <el-form-item v-if="!isUpdateModal" :label="$t('merchant.public_key')" prop="public_key">
          <el-input
            v-if="!isUpdateModal"
            v-model="form.public_key"
            type="textarea"
            :rows="4"
            :placeholder="$t('merchant.public_key')"
            clearable
          />
        </el-form-item>
        <el-form-item :label="$t('merchant.white_ips')" prop="white_ips">
          <el-input v-model="form.white_ips" size="small" :placeholder="$t('merchant.white_ips')" class="search-frame" autocomplete="off" clearable />
          tips: {{ $t('merchant.ips_tips') }}
        </el-form-item>

      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogUserVisible = false">{{ $t('components.cancel') }}</el-button>
        <el-button type="primary" :disabled="listLoading" @click="onClickSubmitBtn">{{ $t('components.submit') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { addMerchantApp, fetchEventList } from '@/api/merchant-manage/merchant-manage'

export default {
  name: 'MerchantAppModal',
  data() {
    return {
      dialogUserVisible: false,
      listLoading: false,
      eventList: [],
      merchant: {},
      form: {
        app_name: '',
        notice_webhook: '',
        qrcode_webhook: '',
        transfer_webhook: '',
        collect_url: '',
        validate_url: '',
        public_key: '',
        white_ips: '',
        event_names: []
      },
      isUpdateModal: false
    }
  },
  computed: {
    eventIsWithBr(index) {
      return function() {
        return (index + 1) % 4 ? '<br/>' : ''
      }
    }
  },
  created() {
    this.getEventList()
  },
  mounted() {
    this.$bus.off('SHOW_ADD_MERCHANT_APP_MODAL')
    this.$bus.on('SHOW_ADD_MERCHANT_APP_MODAL', (value) => {
      this.dialogUserVisible = value[0]
    })
  },
  methods: {
    initData() {
      this.form = {
        app_name: '',
        notice_webhook: '',
        qrcode_webhook: '',
        transfer_webhook: '',
        collect_url: '',
        validate_url: '',
        event_names: []
      }
      this.$nextTick(function() {
        this.$refs['form'].clearValidate()
      })
    },
    getEventList() {
      fetchEventList().then(res => {
        if (res.code === 10000) {
          this.eventList = res.data
        }
      })
    },
    closeModal() {
      this.initData()
    },
    onClickSubmitBtn() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.listLoading = true
          addMerchantApp(this.form).then(res => {
            if (res.code === 10000) {
              this.$message.success('Success')
              this.$bus.emit('RE_GER_MERCHANT_APP_LIST')
              this.dialogUserVisible = false
              this.$emit('getMerchantAppList')
            }
          }).finally(() => {
            this.listLoading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.form-container{
  margin: 0 100px 0
}
</style>
